import { Codebook } from '../Codebook'
import { $t } from '../../composables/i18n'

export enum TabTypeId {
  //General is only on FE, NOT on BE
  GENERAL = 0,
  RESERVATIONS = 1,
  STAY_PACKAGES = 2,
  REVIEWS = 3,
  PRICING = 4,
  OCCUPANCY = 5,
  GIFT_VOUCHERS = 6,
  SERVICES = 7,
  MAP = 8,
  CHECK_IN = 9,
  FACILITIES = 10,
}

export class TabType extends Codebook<TabTypeId> {
  static readonly GENERAL = new TabType(
    TabTypeId.GENERAL,
    () => $t('General'),
    () => $t('General'),
    'general',
    true,
    'info',
  )
  static readonly RESERVATIONS = new TabType(
    TabTypeId.RESERVATIONS,
    () => $t('Reservations'),
    () => $t('Reservations'),
    'reservations',
    true,
    'calendar-check',
  )
  static readonly STAY_PACKAGES = new TabType(
    TabTypeId.STAY_PACKAGES,
    () => $t('Packages'),
    () => $t('Packages'),
    'stay-packages',
    true,
    'boxes-stacked',
  )
  static readonly REVIEWS = new TabType(
    TabTypeId.REVIEWS,
    () => $t('Reviews'),
    () => $t('Reviews'),
    'reviews',
    false,
  )
  static readonly PRICING = new TabType(
    TabTypeId.PRICING,
    () => $t('Pricing'),
    () => $t('Pricing'),
    'pricing',
    true,
    'coins',
  )
  static readonly OCCUPANCY = new TabType(
    TabTypeId.OCCUPANCY,
    () => $t('Occupancy'),
    () => $t('Occupancy'),
    'occupancy',
    true,
    'users',
  )
  static readonly GIFT_VOUCHERS = new TabType(
    TabTypeId.GIFT_VOUCHERS,
    () => $t('Gift Vouchers'),
    () => $t('Vouchers'),
    'gift-vouchers',
    true,
    'ticket',
  )
  static readonly SERVICES = new TabType(
    TabTypeId.SERVICES,
    () => $t('Services'),
    () => $t('Services'),
    'services',
    true,
    'concierge-bell',
  )
  static readonly MAP = new TabType(
    TabTypeId.MAP,
    () => $t('Map'),
    () => $t('Map'),
    'map',
    false,
  )
  static readonly CHECK_IN = new TabType(
    TabTypeId.CHECK_IN,
    () => $t('Check In'),
    () => $t('Check In'),
    'check-in',
    false,
  )
  static readonly FACILITIES = new TabType(
    TabTypeId.FACILITIES,
    () => $t('Facilities'),
    () => $t('Facilities'),
    'facilities',
    true,
    'vacuum',
  )

  private constructor(
    id: TabTypeId,
    public readonly name: () => string,
    public readonly nameShort: () => string,
    public readonly tag: string,
    public readonly hasSettingTab: boolean,
    public readonly icon: string | null = null,
  ) {
    super(id)
  }
}
